import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import searchIcon from "../assets/images/search.svg";
import { searchBlogs } from "../redux/filters/actions";

const SearchSection = () => {
  const dispatch = useDispatch();
  const [input, setInput] = useState("");

  // Debounce effect
  useEffect(() => {
    const setInputAtReduxState = setTimeout(() => {
      dispatch(searchBlogs(input));
    }, 500);
    return () => clearTimeout(setInputAtReduxState);
  }, [input, dispatch]);

  return (
    <div className="border mt-6 border-slate-200 flex items-center w-11/12 lg:w-1/2 mx-auto bg-gray-50 h-12 px-5 rounded-lg text-sm ring-emerald-200">
      <input
        className="outline-none border-none bg-gray-50 h-full w-full mr-2"
        type="search"
        name="search"
        placeholder="Search"
        value={input}
        onChange={(e) => setInput(e.target.value)}
      />
      <img
        className="inline h-6 cursor-pointer"
        src={searchIcon}
        alt="Search"
      />
    </div>
  );
};

export default SearchSection;
